import React from 'react';
import { BarChart3, Package, Target } from 'lucide-react';
import group from "../../../assests/Group3702.png";
import group1 from "../../../assests/Vector.png";
import circle from "../../../assests/semicircle.png";



export const CardMetric = ({
  title = '',
  value,
  subtitle = '',
  variant = 'default',
  className = '',
  performance = 92,
  icon = null
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          borderColor: 'border-[#E30073]',
          iconBg: 'bg-[#E30073]',
          progressBg: 'bg-[#E30073]',
          progressTrack: 'bg-gray-200'
        };
      case 'success':
        return {
          borderColor: 'border-[#63B945]',
          iconBg: 'bg-[#63B945]',
          progressBg: 'bg-[#63B945]',
          progressTrack: 'bg-gray-200'
        };
      case 'warning':
        return {
          borderColor: 'border-[#FE8D19]',
          iconBg: 'bg-[#FE8D19]',
          progressBg: 'bg-[#FE8D19]',
          progressTrack: 'bg-gray-200'
        };
      default:
        return {
          borderColor: 'border-gray-500',
          iconBg: 'bg-gray-500',
          progressBg: 'bg-gray-500',
          progressTrack: 'bg-gray-200'
        };
    }
  };

  const getIcon = () => {
    if (icon) return icon;
    
    switch (variant) {
      case 'primary':
        return <img src={group} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      case 'success':
        return <img src={group1} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      case 'warning':
        return <img src={circle} alt="Warning" className="w-[50px] h-[50px] p-[8px]" />;
      default:
        return <BarChart3 className="w-10 text-white" />;
    }
  };

  const styles = getVariantStyles();

  return (
    <div className="bg-white rounded-lg border border-gray-300 shadow-sm">
  <div className="flex flex-col sm:flex-row items-center sm:items-stretch p-4 sm:p-6">

    {/* Text */}
    <div className="flex-1 text-center sm:text-left">
      <div className="text-3xl sm:text-6xl font-bold text-gray-900">
        {value}
      </div>
      <p className="mt-1 text-sm font-semibold text-gray-700">
        {title}
      </p>
    </div>

    {/* Divider (desktop only) */}
    <div className="hidden sm:block mx-6 w-px bg-gray-300" />

    {/* Icon */}
    <div className="mt-4 sm:mt-0 flex items-center justify-center">
      <div className={`w-10 h-10 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center ${styles.iconBg}`}>
        {getIcon()}
      </div>
    </div>

  </div>
</div>


  );
};